module.exports = __webpack_public_path__ + "img/4-3.89539935.jpg";